import { render } from "./CatCostTypes.vue?vue&type=template&id=46178665"
import script from "./CatCostTypes.vue?vue&type=script&lang=js"
export * from "./CatCostTypes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__